import {Routes} from "@angular/router";
import {MainComponent} from "@components/main/main.component";
import {AccessDeniedComponent} from "@components/access-denied/access-denied.component";
import {all} from "@/app/routes/index";
import {Component404} from "@components/component-404/component-404.component";
import {SportexamLayoutComponent} from "@components/sportexam-layout/sportexam-layout.component";
import {AuthGuard} from "@/app/interceptors/auth.guard";
import {LayoutExternalComponent} from "@components/layout-external/layout-external.component";
import {FrontchannelLogoutComponent} from "@components/frontchannel-logout/frontchannel-logout.component";

import {guardAnalyticsNormatives, guardAnalyticsProtocols} from "@/app/routes/guards/analytics-guards";
import {guardProtocolsWatch} from "@/app/routes/guards/protocols-guard";

const childRoutes: Routes = [
    {path: '', component: MainComponent},

    {
        path: 'checkup-protocols',
        redirectTo: '/404',
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: 'Типы испытаний', url: null},
            ],
        }
    },
    {
        path: 'checkup-protocol/:id',
        redirectTo: '/404',
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: 'Типы испытаний', url: '/checkup-protocols/'},
            ]
        }
    },

    {
        path: 'equipments',
        redirectTo: '/404',
        data: {
            burger: 'Оборудование',
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: 'Оборудование', url: null},
            ],
            title: 'Оборудование'
        }
    },
    {
        path: 'equipments/:id',
        redirectTo: '/404',
        data: {
            burger: 'Оборудование',
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: 'Оборудование', url: '/equipments/'},
            ],
            title: 'Оборудование'
        }
    },

    {path: 'access-denied', component: AccessDeniedComponent},

    ...all,

    {
        path: 'analytics-protocols',
        loadComponent: () => import('@components/analytics/analytics.component').then(c => c.AnalyticsComponent),
        canActivate: [guardAnalyticsProtocols],
        data: {
            burger: 'Протоколы',
            breadcrumbs: [
                {name: 'Аналитика', url: '/'},
                {name: 'Протоколы', url: null},
            ],
            title: 'Протоколы',
            searchString: true
        }
    },
    {
        path: 'results',
        loadComponent: () => import('@components/results/results.component').then(c => c.ResultsComponent),
        canActivate: [],
        data: {
            burger: 'Результаты',
            breadcrumbs: [
                {name: 'Испытания', url: '/'},
                {name: 'Результаты', url: null},
            ],
            title: 'Результаты',
            searchString: true
        }
    },
    {
        path: 'statistics',
        loadComponent: () => import('@components/statistics/statistics.component').then(c => c.StatisticsComponent),
        canActivate: [guardProtocolsWatch],
        data: {
            breadcrumbs: [
                {name: 'Испытания', url: '/'},
                {name: 'Статистика', url: null},
            ],
            title: 'Статистика',
            searchString: true
        }
    },
    {
        path: 'analytics-normatives',
        loadComponent: () => import('@components/analytics-normatives/analytics-normatives.component').then(c => c.AnalyticsNormativesComponent),
        canActivate: [guardAnalyticsNormatives],
        data: {
            burger: 'Нормативы',
            breadcrumbs: [
                {name: 'Аналитика', url: '/'},
                {name: 'Нормативы', url: null},
            ],
            title: 'Нормативы',
            searchString: true
        }
    },
    {
        path: 'admin/rights-roles',
        loadComponent: () => import('@components/admin/rights-roles/rights-roles.component').then(c => c.RightsRolesComponent),
        data: {
            breadcrumbs: [
                {name: 'Администрирование', url: '/'},
                {name: 'Права и роли', url: null},
            ],
        }
    },


    {path: '404', component: Component404},
];

export const routes: Routes = [
    // Вне layout и без гарда: Keycloak открывает эту страницу в iframe уже после
    // того, как SSO-сессия закрыта, и гард её бы не пропустил.
    {path: 'frontchannel-logout', component: FrontchannelLogoutComponent},
    {path: '', component: SportexamLayoutComponent, children: childRoutes, canActivate: [AuthGuard]},
    {path: 'external/:id', component: LayoutExternalComponent, canActivate: [AuthGuard],},

];
